import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import router from "@/router";
import Api from "@/components/Api/index"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: "", //主要token
    newAccessToken:"",
    refreshToken: "", //刷新token
    themeColor: '#FF6637',
    orderFlowDirection:0,
    userInfor: {
      name: '',
      imageUrl: '',
      phoneNumber: '',
      companyName:'',
      userId:'',
      officialAccount:null,
    },
    checkedIndex: 0, //导航栏的选中的tab
    planId: 0,
    budgetMainId: null,
    rightPopupIndex: -1,
    rightPopupIndexType: 1,
    tianyanchaQueryData: '',
    supplierBasics: {
      //联系人信息
      numberList: [],
      //收款信息
      collectionList: [],
      //区域信息
      areaSelect: [],
      //机构/资源供应商信息维护
      mechanismSupplier: {},
      //所有需要上传的文件
      uploadList: []
    },
  },
  mutations: {
    setAccessToken(state, val) {
      state.accessToken = val;
    },
    setNewAccessToken(state, val) {
      state.newAccessToken = val;
    },
    setRefreshToken(state, val) {
      state.refreshToken = val;
    },
    setCheckIndex(state, index) {
      state.checkedIndex = index
    },
    setPlanId(state, planId) {
      state.planId = planId
    },
    setBudgetMainId(state, budgetMainId) {
      state.budgetMainId = budgetMainId
    },
    setRightPopupIndex(state, rightPopupIndex) {
      state.rightPopupIndex = rightPopupIndex
    },
    setRightPopupIndexType(state, rightPopupIndexType) {
      state.rightPopupIndexType = rightPopupIndexType
    },
    setUserInfo(state, val) {
      state.userInfor.name = val.name;
      state.userInfor.imageUrl = val.imageUrl;
      state.userInfor.phoneNumber = val.phoneNumber;
      state.userInfor.companyName = val.companyName;
      state.userInfor.userId = val.id;
      state.userInfor.officialAccount = val.officialAccount
    },
    //退出登陆
    closeLogin(state) {
      state.accessToken = "";
      state.newAccessToken = "";
      state.refreshToken = "";
      state.editableTabs = [];
      router.push({
        name: "login",
        params: {},
      });
    },
    //加塞法人信息到机构
    gasserLegaInfo(state, value) {
      state.supplierBasics.mechanismSupplier.legalPerson = value.legalPerson
      state.supplierBasics.mechanismSupplier.certificatesLegal = value.certificatesLegal
      state.supplierBasics.mechanismSupplier.certificatesLegalNumber = value.certificatesLegalNumber
      state.supplierBasics.mechanismSupplier.legalPhone = value.legalPhone
    },
    setCollectionList(state, value) {
      state.supplierBasics.collectionList = [value]
    },
    setNumberList(state, value) {
      state.supplierBasics.numberList = value
    },
    setMechanismSupplier(state, value) {
      state.supplierBasics.mechanismSupplier = value
    },
    setSupplierBasics(state, value) {
      state.supplierBasics = value
    },
    setAreaSelect(state, value) {
        let arr = [];
        value.forEach(e => {
            arr.push({
                nameCn: e.nameCn,
                nameEn: e.nameEn,
                type: e.type,
                linkId: e.pid
            })
        })
        state.supplierBasics.areaSelect = arr;
    }
  },
  actions: {
    getApplyButton(context, payload) {
      new Api("apply").applyButtonQuery(payload.bids).then(res => {
        if (res.status == 200) {
          payload.success(res.data)
        } else {
          payload.fail(res.statusText)
        }
      })
    },
    savePlatSupplierData(context, payload) {
      context.state.supplierBasics.mechanismSupplier.supplierAreaList = context.state.supplierBasics.areaSelect
      context.state.supplierBasics.mechanismSupplier.numberList = context.state.supplierBasics.numberList
      context.state.supplierBasics.mechanismSupplier.collectionList = context.state.supplierBasics.collectionList
      new Api("user").customizerSettleIn(context.state.supplierBasics.mechanismSupplier).then(res => {
        if (res.status == 200 && res.pid !== '') {
          payload.success(res.pid)
        } else {
          payload.fail(res.statusText)
        }
      })
    }
  },
  modules: {},
  plugins: [
    persistedState({
      storage: window.sessionStorage,
      reducer(val) {
        return {
          accessToken: val.accessToken,
          newAccessToken: val.newAccessToken,
          refreshToken: val.refreshToken,
          userInfor: val.userInfor,
          themeColor: val.themeColor,
          checkedIndex: val.checkedIndex, //导航栏的选中的tab
          planId: val.planId,
          budgetMainId: val.budgetMainId,
          rightPopupIndex: val.rightPopupIndex,
          rightPopupIndexType: val.rightPopupIndexType
        }
      }
    })
  ]
})